import { Building2, FileText, Mail, MapPin, Phone, ScrollText } from 'lucide-react';

import type { MatchProvidedDetails } from '../types';
import { ReportCard } from '../../composites';
import { DataRow } from '../../primitives';

/** The "Provided Details" section: the merchant data submitted with the inquiry. */
export const MatchProvidedDetailsSection = ({
  providedDetails,
}: {
  providedDetails?: MatchProvidedDetails | null;
}) => {
  const details = providedDetails ?? {};

  return (
    <ReportCard title="Provided Details" Icon={FileText} showTooltip={false}>
      <div className="grid grid-cols-1 gap-x-12 md:grid-cols-2">
        <DataRow
          label="Merchant Name"
          Icon={Building2}
          value={details.merchantName}
          copyable
          copyValue={details.merchantName ?? ''}
          emptyLabel="Not Provided"
          disableTranslation
        />
        <DataRow label="MCC" Icon={ScrollText} value={details.mcc} emptyLabel="Not Provided" />
        <DataRow
          label="Address"
          Icon={MapPin}
          value={details.address}
          copyable
          copyValue={details.address ?? ''}
          emptyLabel="Not Provided"
        />
        <DataRow label="DBA" Icon={Building2} value={details.dba} emptyLabel="Not Provided" />
        <DataRow
          label="Email"
          Icon={Mail}
          value={details.email}
          copyable
          copyValue={details.email ?? ''}
          emptyLabel="Not Provided"
          disableTranslation
        />
        <DataRow
          label="Phone Number"
          Icon={Phone}
          value={details.phoneNumber}
          copyable
          copyValue={details.phoneNumber ?? ''}
          emptyLabel="Not Provided"
        />
      </div>
    </ReportCard>
  );
};
